import React, { useState, useEffect, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "reactstrap";
import { contvertHTMLToPlain } from "../../utils/constants";
import MyLinkModule from "./MyQuillModule";
import "./quilTextEditor.css";
import {connect} from "react-redux"
import { applyCustomFontStyles } from "../../pages/trivia/data";
Quill.register("modules/myLinkModule", MyLinkModule);

// Quill's own Tab binding inserts a literal \t, and its `indent` binding is gated
// on the line already being a list/blockquote, so a plain <p> never indents.
const KEYBOARD_MODULE = {
  bindings: {
    // Named `tab` to REPLACE Quill's binding in its original slot, which sits
    // after the built-in list `indent` — so Tab in a list stays Quill's.
    tab: {
      key: 9,
      handler: function indentLine() {
        this.quill.format("indent", "+1", Quill.sources.USER);
        return false;
      },
    },
    // A new name, so it registers after the built-in `outdent`. Returning true
    // at level 0 leaves the keystroke alone so Shift+Tab still moves focus.
    outdentPlainLine: {
      key: 9,
      shiftKey: true,
      handler: function outdentLine(range, context) {
        if (!context.format.indent) {
          return true;
        }
        this.quill.format("indent", "-1", Quill.sources.USER);
        return false;
      },
    },
  },
};


 function QuizTextEditor({
  styles,
  value,
  onChange,
  placeholder,
  blockId,
  hideToolbar,
  questionId,
  disabled,
  maxLimit,
  isMessaging,
  allowHyperlink,
  currentTrivia,
  questionThemeSettings,
  closableToolbar
}) {
  const quillRef = useRef(null);
  const [htmlVal, setHtmlVal] = useState(value);
  const [cursorPosition, setCursorPosition] = useState(null);
  const [isToolbarClosed, setIsToolbarClosed] = useState(false);
  const suppressReopenOnFocusRef = useRef(false);
  useEffect(() => {
    setHtmlVal(value);
  }, [questionId && questionId, value]);

  const handleCloseToolbar = () => {
    setIsToolbarClosed(true);
    if (quillRef.current) {
      // Re-focus so hiding the toolbar doesn't hide the cursor. Self-heals
      // next tick — Safari/iOS may never fire the focus event this expects.
      suppressReopenOnFocusRef.current = true;
      quillRef.current.getEditor().focus();
      setTimeout(() => {
        suppressReopenOnFocusRef.current = false;
      }, 0);
    }
  };

  // A real mouseenter can never be an echo of our own close-triggered
  // .focus() call above, so hover always reopens unconditionally.
  const handleHoverReopenToolbar = () => {
    setIsToolbarClosed(false);
  };

  // The inline display:none below only wins because quilTextEditor.css's
  // :hover/:focus-within rules have no `!important` — don't add one there.
  const handleReopenToolbar = () => {
    if (suppressReopenOnFocusRef.current) {
      // The re-focus above bubbles into this handler; skip once so it
      // doesn't reopen the toolbar we just closed.
      suppressReopenOnFocusRef.current = false;
      return;
    }
    setIsToolbarClosed(false);
  };

 
  const handlePaste = (e) => {
    if (!quillRef.current) return;

    // setTimeout(()=>{
    //   setHtmlVal(contvertHTMLToPlain(htmlVal))
    //   onChange(contvertHTMLToPlain(htmlVal))
    // },1000)

    // const clipboardData = e.clipboardData || window.clipboardData;
    // console.log(clipboardData,e)
    // const pastedText = clipboardData.getData("text/plain");
    // const selection = quillRef.current.getEditor().getSelection();
    // if (selection) {
    //   quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(
    //     selection.index,
    //     pastedText,
    //     "api"
    //   );
    //   quillRef.current.getEditor().setSelection(selection.index + pastedText.length, 0);
    // }
    // e.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "v" && (e.metaKey || e.ctrlKey)) {
      // Detect paste (Ctrl+V or Cmd+V)
      handlePaste(e);
    }
  };



  const htmlLength = htmlVal ? htmlVal.replace(/<[^>]+>/g, "").length : 0;

  return (
    <div
      style={{ position: "relative", ...styles }}
      className="quill-rte-main-wrapper"
      onMouseEnter={closableToolbar ? handleHoverReopenToolbar : undefined}
      onFocus={closableToolbar ? handleReopenToolbar : undefined}
    >
      {maxLimit ? (
        <span className="font-11px">
          {htmlLength}/{maxLimit} {isMessaging?'(Message content)':''}
        </span>
      ) : (
        ""
      )}
      <div
        id={blockId ? `quill_toolbar_${blockId}` : `quill_toolbar`}
        style={{
          ...(disabled && { display: "none" }),
          ...(closableToolbar && isToolbarClosed && { display: "none" }),
        }}
      >
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-bold"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-italic"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-underline"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-list"
          value="ordered"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-list"
          value="bullet"
        ></button>
        {allowHyperlink && (
          <button
            style={{ display: !hideToolbar ? "block" : "none" }}
            className="ql-link"
          ></button>
        )}
        {closableToolbar && !disabled && (
          <button
            type="button"
            className="quill-toolbar-close-btn"
            onClick={handleCloseToolbar}
            aria-label="Close"
          >
            &times;
          </button>
        )}
      </div>

      {cursorPosition}

      <ReactQuill
        modules={{
          toolbar: hideToolbar
            ? false
            : blockId
            ? `#quill_toolbar_${blockId}`
            : `#quill_toolbar`,
          clipboard: {
            newLines: false,
          },
          keyboard: KEYBOARD_MODULE,
          ...(allowHyperlink && {
            myLinkModule: {},
          })
          
        }}
        
        ref={quillRef}
        value={htmlVal}
        onChange={(value, delta, source, editor) => {
          console.log(editor);
          if (source === "user" || source === "api") {
            // react-quill re-emits its own re-parse of `value` as an `api`
            // change; saving that stores a whitespace-stripped title unprompted.
            const propagate = source === "user";
            const plainVal = contvertHTMLToPlain(value || "<p></p>");
            if (value === "<p><br></p>") {
              setHtmlVal("");
              if (propagate) {
                onChange("");
              }
            } else {
              let nextVal = value;
              if (maxLimit && plainVal.length > maxLimit) {
                nextVal = contvertHTMLToPlain(value).slice(0, maxLimit);
              }
              setHtmlVal(nextVal);
              if (propagate) {
                onChange(nextVal);
              }
            }
          }
        }}
        placeholder={placeholder}
        readOnly={disabled}
        formats={[
          'font', 'header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'indent'
        ]}
        // onKeyUp={handleKeyUp}
        // onKeyPress={handleKeyPress}
        style={{
          ...applyCustomFontStyles(questionThemeSettings)
        }}
      />
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    currentTrivia: state.trivia.currentTrivia,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizTextEditor);
